/**
 * Merges class names, filtering out falsy values
 * @param classes Array of class names or falsy values
 * @returns Merged class name string
 */
export function cn(...classes: (string | undefined | null | false | 0)[]): string {
  return classes.filter(Boolean).join(' ');
}

